export enum CollectionStatusEnum {
  active = 'ACTIVE',
  activeAdminOnly = 'ACTIVE_ADMIN_ONLY',
  inactive = 'INACTIVE',
}
